
import React, { useContext, useState } from 'react';
import withAuth from '../utils/withAuth';
import { useNavigate } from 'react-router-dom';
import { Button, IconButton, TextField, Box, Typography } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import { AuthContext } from '../contexts/AuthContext';

function HomeComponent() {
    const navigate = useNavigate();
    const [meetingCode, setMeetingCode] = useState("");
    const { addToUserHistory } = useContext(AuthContext);

    const handleJoinVideoCall = async () => {
        await addToUserHistory(meetingCode);
        navigate(`/${meetingCode}`);
    }

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#f0f2f5', p: { xs: 2, sm: 4 } }}>
            
            {/* NavBar */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 4,
                    gap: { xs: 1, sm: 0 },
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                    Communication App
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                    <IconButton onClick={() => navigate("/history")}>
                        <RestoreIcon sx={{ fontSize: { xs: 20, sm: 28 } }} />
                    </IconButton>
                    <Typography variant="body1" sx={{ display: { xs: 'none', sm: 'block' } }}>
                        History
                    </Typography>

                    <Button
                        variant="outlined"
                        onClick={() => {
                            localStorage.removeItem("token");
                            navigate("/auth");
                        }}
                    >
                        Logout
                    </Button>
                </Box>
            </Box>

            {/* Main Content */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column-reverse', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: { xs: 3, md: 6 },
                }}
            >
                {/* Left Panel */}
                <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Providing Quality Video Call Just Like Zoom
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            justifyContent: { xs: 'center', sm: 'flex-start' },
                            mt: 2,
                        }}
                    >
                        <TextField
                            fullWidth
                            sx={{ maxWidth: { xs: '100%', sm: 250 } }}
                            label="Meeting Code"
                            variant="outlined"
                            value={meetingCode}
                            onChange={e => setMeetingCode(e.target.value)}
                        />
                        <Button
                            variant="contained"
                            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
                            onClick={handleJoinVideoCall}
                        >
                            Join
                        </Button>
                    </Box>
                </Box>

                {/* Right Panel */}
                <Box sx={{ flex: 1, textAlign: 'center' }}>
                    <Box
                        component="img"
                        srcSet="/logo3.png"
                        alt="Logo"
                        sx={{
                            maxWidth: { xs: '70%', sm: '100%' },
                            height: 'auto',
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default withAuth(HomeComponent);
